import type { SharePointConnectionOut } from '@biasafe.models';

/**
 * What the dialog says about the firm's SharePoint connection.
 *
 * THE SAME RULE AS `phoneHealth.ts`: say what is true and what to do, and never
 * print `lastError`. The server stores a short fixed sentence, but the card's only
 * use for it is to tell "the app cannot read that site" from "Microsoft is down".
 */
export type SharepointHealth =
  { kind: 'ok' } | { kind: 'pending' | 'error'; message: string };

type Connection = Pick<SharePointConnectionOut, 'status' | 'lastError'>;

export function sharepointHealth(connection: Connection): SharepointHealth {
  switch (connection.status) {
    case 'CONNECTED':
      return { kind: 'ok' };
    case 'PENDING_CONSENT':
      return {
        kind: 'pending',
        message:
          'Waiting for a Microsoft 365 administrator to approve access. Connect again to restart the approval.',
      };
    default:
      return {
        kind: 'error',
        message:
          'The last check with Microsoft failed. Check that the BIASafe app still has access to the site, then browse again.',
      };
  }
}

/** A file size for a person: 1.2 MB, 48 KB, 120 B. */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
